import React, { useContext, useState } from 'react';
import { GiftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Button, ConfigProvider, Popover } from 'antd';
import { ROUTER_INVITE_CENTER } from '@/entry/route';
import './styles.less';
import Login from '@/pages/Auth/Login';
import { EasyDrawContext } from '@/store';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

export const InviteEntry = observer(() => { 
  const navigate = useNavigate();
  const store = useContext(EasyDrawContext)
  const [loginVisible, setLoginVisible] = useState(false)
  const [tipVisible, setTipVisible] = useState(false)
  const prefixCls = 'invite-entry'
  const LS_KEY = 'INVITE_ENTRY_TOOLTIP_CLOSED'
  const { t } = useTranslation('app', { keyPrefix: 'layout.header' });

  React.useEffect(() => {
    try {
      const closed = localStorage.getItem(LS_KEY)
      if (!closed) {
        setTipVisible(true)
      }
    } catch (e) {
      setTipVisible(true)
    }
  }, [])

  const handleClick = () => {
    if (store?.isLogin) {
      navigate(ROUTER_INVITE_CENTER);
    } else {
      setLoginVisible(true)
    }
  };

  const handleKnow = () => {
    try { localStorage.setItem(LS_KEY, '1') } catch (e) {}
    setTipVisible(false)
  }

  const handleGoSee = () => {
    try { localStorage.setItem(LS_KEY, '1') } catch (e) {}
    setTipVisible(false)
    handleClick()
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#f97316'
        }
      }}
    >
      <Popover
        open={tipVisible}
        placement="bottomRight"
        arrow={false}
        content={
          <div className={`${prefixCls}-tooltip-content`}>
            <div className="title">{t('invite_gift_title')}</div>
            <div className="desc">{t('invite_gift_desc')}</div>
            <div className="actions">
              <Button size="small" onClick={handleKnow}>{t('know_it')}</Button>
              <Button size="small" type="primary" onClick={handleGoSee} style={{ marginLeft: 8 }}>{t('go_see')}</Button>
            </div>
          </div>
        }
      >
        <Button 
          className="invite-entry-btn" 
          onClick={handleClick}
          icon={<GiftOutlined className="icon" />}
          type="default"
        >
          {t('invite_gift')}
        </Button>
      </Popover>
      <Login visible={loginVisible} onClose={() => setLoginVisible(false)} />
    </ConfigProvider>
  );
});
